<template>
    <div>
        <d-button
            :class="additionalClasses"
            @click="$modal.show('productQrModal')"
        >
            {{buttonText}}
        </d-button>
    </div>
</template>

<script>
    import { getQueryParameterByName } from '../../assets/js/utils'
    import { DButton } from '@ahml/domrfbank-ui/elements/DButton';

    export default {
        name: "MortgageSendWithLk",
        components: {
            DButton
        },
        props: {
            additionalClasses: {
                type: String,
                default: "",
            },
            buttonText: {
                type: String,
                default: "Подать заявку",
            },
            lkRedirect: {
                type: String,
                default: "https://lk.domrfbank.ru",
            },
            programCode: {
                type: String,
                default: "",
            },
            calculatorData: {
                type: Object,
                default: () => {
                    return {}
                },
            }
        },
        data() {
            return {
                id: '',
                utm: '',
                lkiProgram: ''
            }
        },
        computed: {
            fullUtm() {
                return location.protocol+'//'+location.host+location.pathname+this.utm;
            },
            link() {
                return (this.$props.programCode && this.$props.calculatorData)
                ? `${this.$props.lkRedirect}/auth/calculator?source=${encodeURIComponent(this.fullUtm)}&programCode=${this.lkiProgram}&initialPayment=${this.$props.calculatorData.initialPayment}&creditAmount=${this.$props.calculatorData.creditAmount}&creditPeriod=${this.$props.calculatorData.creditPeriod}`
                : `${this.$props.lkRedirect}/auth/calculator?source=${encodeURIComponent(this.fullUtm)}`
            }
        },
        mounted() {
            switch(this.$props.programCode) {
                case "product_family":
                    this.lkiProgram = 'family_mortgage';
                    break;
                case "product_preferential":
                    this.lkiProgram = 'preferential_mortgage';
                    break;
                case "product_building":
                    this.lkiProgram = 'flat_construction';
                    break;
                default:
                    this.lkiProgram = this.$props.programCode;
            }

            if (getQueryParameterByName('utm_source') === 'cian') {
                sessionStorage.setItem('cianUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'vbr') {
                sessionStorage.setItem('vbrUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'sravni') {
                sessionStorage.setItem('sravniUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'mobilebanker') {
                sessionStorage.setItem('mortgageMobilebanker', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'yandex') {
                sessionStorage.setItem('yandexUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'mytarget') {
                sessionStorage.setItem('mytargetUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'ozon') {
                sessionStorage.setItem('ozonUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'buzzoola') {
                sessionStorage.setItem('buzzoolaUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'avito') {
                sessionStorage.setItem('avitoUrl', location.search);
            }
            else if (getQueryParameterByName('utm_source') === 'vyberu') {
                sessionStorage.setItem('vyberuUrl', location.search);
            }

            if (sessionStorage.getItem('cianUrl')) {
                this.utm = sessionStorage.getItem('cianUrl');
            }
            else if (sessionStorage.getItem('vbrUrl')) {
                this.utm = sessionStorage.getItem('vbrUrl');
            }
            else if (sessionStorage.getItem('sravniUrl')) {
                this.utm = sessionStorage.getItem('sravniUrl');
            }
            else if (sessionStorage.getItem('mortgageMobilebanker')) {
                this.utm = sessionStorage.getItem('mortgageMobilebanker');
            }
            else if (sessionStorage.getItem('yandexUrl')) {
                this.utm = sessionStorage.getItem('yandexUrl');
            }
            else if (sessionStorage.getItem('mytargetUrl')) {
                this.utm = sessionStorage.getItem('mytargetUrl');
            }
            else if (sessionStorage.getItem('ozonUrl')) {
                this.utm = sessionStorage.getItem('ozonUrl');
            }
            else if (sessionStorage.getItem('buzzoolaUrl')) {
                this.utm = sessionStorage.getItem('buzzoolaUrl');
            }
            else if (sessionStorage.getItem('avitoUrl')) {
                this.utm = sessionStorage.getItem('avitoUrl');
            }
            else if (sessionStorage.getItem('vyberuUrl')) {
                this.utm = sessionStorage.getItem('vyberuUrl');
            }
            else {
                this.utm = location.search;
            }
        }
    }
</script>
